module.exports = __webpack_public_path__ + "img/icom9.a14f55fe.png";